import { Injectable } from "@angular/core";
import { CtWebapiGenericResponse, CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";

@Injectable()
export class RankingController {


    controller = '/Ranking';

      constructor(
            private ctWebApiService : CtWebapiService,
        ) {}

    bid(param : RankingBidDTO): Promise<any>{

        return new Promise<any>((resolve) => {
            this.ctWebApiService
            .post(new DataRequest(`${this.controller}/Bid`, { hideSpinner: false}), param)
            .subscribe((res: CtWebapiGenericResponse<any>) => {
                    resolve(res.Result);
                });
        });

    }

}


export class RankingBidDTO
{

    constructor(public Oid: number, public Amount : number, public Quantity : number, public PlaceOid?: number){}

}
